<div class="dropdown">
  <button #dropdownToggle class="btn btn-outline-primary dropdown-toggle shadow-sm border-0"
    data-bs-auto-close="outside" data-bs-toggle="dropdown">Filter by Tags
    <i class="fa-solid fa-filter"></i>
  </button>

  <div class="dropdown-menu p-3 shadow-lg rounded-3" style="min-width: 260px;">

    <div class="mb-2">
      <label class="form-label">Tag Key</label>
      <select class="form-control selectpicker" [(ngModel)]="selectedTagKey" (ngModelChange)="onTagKeyChange($event)"
        data-live-search="true">
        <option value="" disabled>Select Tag Key</option>
        <option *ngFor="let key of tagKeys" [value]="key">{{ key }}</option>
      </select>
    </div>

    <div class="mb-3">
      <label class="form-label">Tag Value</label>
      <select class="form-control selectpicker" [(ngModel)]="selectedTagValue" data-live-search="true">
        <option value="" disabled selected>Select Tag Value</option>
        <option *ngFor="let val of tagValues" [value]="val">{{ val }}</option>
      </select>
    </div>

    <div class="d-flex justify-content-end gap-2">
      <button class="btn btn-sm btn-outline-secondary px-3" (click)="closeDropdown()">Close</button>
      <button class="btn btn-sm btn-primary px-3" (click)="applyFilter()">Apply</button>
    </div>
  </div>
</div>